<template>
  <div class='nav-bar-app-component'>

    <div class='nav-bar-logo-container'>
      <router-link to='/'>
        <img class='nav-bar-logo' src='@/assets/Logo_LAtelier_blanc.png'/>
      </router-link>
    </div>
    <transition name="slide">
      <div :class="{ oppened: (isTablet && !mobileMenuOpened) }" ref="navigationContainer" class='nav-bar-routes-container'>

        <div ref="selectorContainer" class="selector-container">
          <div ref="selector" class="selector"></div>
        </div>

        <router-link name="HomePage" class='nav-bar-routes' to="/">SHOKUNIN</router-link>
        <router-link name="TrainingPage" class='nav-bar-routes' to='/trainings'>NOS FORMATIONS</router-link>
        <router-link name="QuestionPage" class='nav-bar-routes' to='/question'>UNE QUESTION ?</router-link>

        <span class='nav-bar-modal-participation' @click="participateClicked">PARTICIPER</span>
      </div>
    </transition>
    <div class='nav-bar-logo-container burger' @click="mobileMenuOpened = !mobileMenuOpened">
      <img src='@/assets/burger.svg'/>
    </div>

    <ParticipateModal v-if='showModalComponent' :trainingId="currentTrainingId" @close="closeModal"/>

  </div>
</template>

<script>
import { gsap } from 'gsap'
import ParticipateModal from './modals/participateModal'
import data from '@/data/fixtures'

export default {
  name: 'NavBarAppComponent',

  components: {
    ParticipateModal
  },

  props: {
    showTrainings: Boolean
  },

  data () {
    return {
      showModalComponent: false,
      mobileMenuOpened: false,
      menuTween: false,
      isTablet: false
    }
  },

  computed: {
    currentTrainingId () {
      const name = this.$route.params.trainingName
      if (!name) return -1
      const training = data.trainings.find(t => t.name === name)
      return training ? training.id : -1
    }
  },

  mounted () {
    window.addEventListener('resize', this.onResize)
    this.initSelector()
    this.checkTablet()

    if (this.$route.name === 'HomePage') {
      gsap.set('.nav-bar-app-component', { alpha: 0 })
      gsap.to('.nav-bar-app-component', {
        duration: 2.5,
        alpha: 0.98,
        delay: 1
      })
    }
  },

  destroyed () {
    window.removeEventListener('resize', this.initSelector)
  },

  methods: {

    checkTablet () {
      this.isTablet = window.innerWidth < 840
      return this.isTablet
    },

    participateClicked () {
      document.body.style.overflow = 'hidden'
      this.showModalComponent = true
      this.mobileMenuOpened = false
      if (this.$ga) {
        this.$ga.event('participate', 'click')
      }
    },

    onResize () {
      this.initSelector()
      this.checkTablet()
    },

    closeModal () {
      this.showModalComponent = false
      document.body.style.overflow = ''
    },

    openNavigation ({ path }) {
      if (path[0].className === 'nav-bar-logo') return

      const width = window.innerWidth
      if (width > 840) return

      if (this.menuTween.reversed()) {
        this.menuTween.play()
      } else {
        this.menuTween.reverse()
      }
    },

    initSelector () {
      const { name } = this.$route
      const selector = this.$refs.selector
      const container = this.$refs.selectorContainer

      setTimeout(_ => {
        const elem = this.$el.querySelector(`[name=${name}]`)
        if (!elem) return
        const { x, y, height, width } = elem.getClientRects()[0]

        gsap.set(selector, { height, width })
        gsap.set(container, { x, y, height, width })
      }, 0)
    },

    routeChangeMobile ({ name }) {
      const selector = this.$refs.selector
      const container = this.$refs.selectorContainer

      const elem = this.$el.querySelector(`[name=${name}]`)
      if (!elem) return
      const { y, height } = elem.getClientRects()[0]
      const selectorY = selector.getClientRects()[0].y

      const duration = 0.8

      const tl = gsap.timeline()
        .to(selector, {
          duration: duration / 2,
          height: height / 2,
          ease: 'power4.inOut'
        }, 'start')
        .to(container, { duration, y, ease: 'power4.inOut' }, 'start')
        .to(selector, {
          duration: duration / 2,
          height,
          ease: 'power4.out'
        }, `start+=${duration / 2}`)

      if (selectorY < y) {
        tl
          .to(selector, {
            duration: duration / 2,
            y: `+=${height / 2}`,
            ease: 'power4.inOut'
          }, 'start')
          .to(selector, {
            duration: duration / 2,
            y: 0,
            ease: 'power4.out'
          }, `start+=${duration / 2}`)
      }
    },

    routeChangeDesktop ({ name }) {
      const selector = this.$refs.selector
      const container = this.$refs.selectorContainer

      const elem = this.$el.querySelector(`[name=${name}]`)
      const { x, height, width } = elem.getClientRects()[0]
      const selectorX = selector.getClientRects()[0].x

      const duration = 0.8

      const tl = gsap.timeline()
        .to(selector, {
          duration: duration / 2,
          width: width / 2,
          ease: 'power4.inOut'
        }, 'start')
        .to(container, { duration, x, ease: 'power4.inOut' }, 'start')
        .to(selector, {
          duration: duration / 2,
          width,
          ease: 'power4.out'
        }, `start+=${duration / 2}`)

      if (selectorX < x) {
        tl
          .to(selector, {
            duration: duration / 2,
            x: `+=${width - height * 2}`,
            ease: 'power4.inOut'
          }, 'start')
          .to(selector, {
            duration: duration / 2,
            x: 0,
            ease: 'power4.out'
          }, `start+=${duration / 2}`)
      }
    }

  },

  watch: {
    '$route' (route, oldRoute) {
      if (route.name === oldRoute.name) return
      this.mobileMenuOpened = false

      if (this.checkTablet()) { return this.routeChangeMobile(route) }
      return this.routeChangeDesktop(route)
    },
    mobileMenuOpened (open) {
      if (open) {
        setTimeout(this.initSelector, 600) // wait animation
      }
    }
  }

}
</script>

<style lang='scss' scoped>
$width-tab-navbar: 200px;

.selector-container {
  position: absolute;
  display: flex;

  justify-content: left;

  left: 0;
  top: 0;

  transition: opacity .3s ease;
}

.selector {
  background: #fff;
  transform-origin: center center;
}

.nav-bar-app-component {
  display: flex;
  flex-direction: row;
  justify-content: center;

  position: fixed;

  width: 100vw;
  height: 74px;

  top: 0;

  background-color: #3A3635;
  border-bottom: 2px solid rgba(135, 135, 135, 0.5);
  color: #D8D8D8;
  letter-spacing: 2.11px;

  z-index: 1000;

  @include media(desktop) {
    justify-content: flex-end;
  }

  @include media(tablet) {
    flex-direction: column;
    height: unset;
  }
}

.slide-enter, .slide-leave-to{
  transform: scaleY(0);
}
.nav-bar-logo-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 74px;
  width: 74px;
  &.burger {
    right: 0;
    left: unset;

    height: 32px;
    width: 32px;
    margin: 21px;
    margin-top: 26px;

    visibility: hidden;
  }

  @include media(tablet) {
    position: unset;

    &.burger {
      visibility: visible;
      position: absolute;
    }
  }

  img {
    height: 100%;
  }
}

.nav-bar-routes-container {
  max-width: 1400px;

  align-items: center;
  display: flex;
  font-size: 0.8rem;
  height: 100%;
  justify-content: space-around;
  width: 100%;
  overflow: hidden;
  transition: transform .4s ease-in-out, height .3s ease;
  transform-origin: top;

  @include media(desktop) {
    max-width: unset;
    width: calc(100% - 64px)
  }

  @include media(tablet) {
    height: 193px;
    width: 100%;
    margin-bottom: 18px;
  }

  &.oppened {
    height: 0;
    margin-bottom: 0;

    .selector-container {
      opacity: 0;
    }
  }

  .nav-bar-routes{
    color: #D8D8D8;
    font-weight: bold;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    min-width: 170px;
    white-space: nowrap;

    z-index: 1;

    @include media(tablet) {
      margin: 6px 0;
    }

    &.router-link-exact-active {
      color: #3A3635;
      font-weight: 500;
    }
  }

  .nav-bar-modal-participation {
    border: 1px solid #D8D8D8;
    cursor: pointer;
    font-weight: bold;
    padding: 10px 20px;
    text-align: center;
    min-width: 170px;
    white-space: nowrap;
    background-color: transparent;
    transition: all 0.3s ease;

    @include media(tablet) {
      margin: 6px 0;
    }

    &:hover {
      color: #3A3635;
      background-color: #D8D8D8;
    }
  }

  @include media(tablet) {
    flex-direction: column;
  }
}

.nav-bar-modal {
  height: 900px;
  width: 612px;

  .nav-bar-modal-title {
    color: #979797;
    font-size: 1.8rem;
    font-weight: 900;
    letter-spacing: 3.03px;
    text-align: left;
    padding-left: 15%;
    padding-top: 30px;
  }

  .nav-bar-modal-underline {
    border-bottom: 4px solid #979797;
    padding-bottom: 10px;
    margin-left: 15%;
    width: 10%;
  }

  .nav-bar-modal-button {
    background-color: #FFF;
    border: none;
    color: #B98A30;
    font-size: 1.7rem;
    font-weight: 900;
    position: relative;
    top: -50px;
    right: -280px;
  }

  .nav-bar-contact-component {
    height: 77%;
  }
}
</style>
